<mat-sidenav-container class="sidenav-container">
  <!-- SIDENAV -->

  <mat-sidenav
    #drawer
    class="sidenav"
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="false"
  >
    <mat-toolbar>dashboard</mat-toolbar>
    <mat-nav-list>
      <a mat-list-item routerLink="/global" (click)="drawer.close()">{{
        "global" | translation
      }}</a>
      <a
        mat-list-item
        [routerLink]="modules.path"
        (click)="drawer.close()"
        *ngFor="let modules of arrayModulesToReturn"
        >{{ modules.name }}</a
      >

      <!-- <a mat-list-item routerLink="/global" (click)="drawer.close()">Général</a>
        <a mat-list-item routerLink="/kiosk" (click)="drawer.close()">Kiosk</a>
        <a mat-list-item routerLink="/quiz" (click)="drawer.close()">Quiz</a>
        <a mat-list-item routerLink="/datas" (click)="drawer.close()">Données</a> -->
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <!-- TOP TOOLBAR-->

    <mat-toolbar id="toolbar-top">
      <section>
        <button type="button"
                aria-label="Toggle sidenav"

                (click)="drawer.toggle()"
                *ngIf="isHandset$ | async">
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
        </button>

        <!-- **** LISTE DES GROUPES **** -->
        <img id="logo" src="assets/img/logo-plvbroker.svg" alt="" *ngIf="window.location.href.includes('digitalbroker') || window.location.href.includes('localhost') " />
        <img id="logo" src="assets/ui/logo-id2son.svg" alt="" *ngIf="window.location.href.includes('id2son')" />
        <img id="logo" src="assets/ui/logo-absolute-event.png" alt="" *ngIf="window.location.href.includes('absolute-event')" />
        <!-- <div fxLayout="row" *ngIf="global">
    <div *ngFor="let item of global.listLang">
      <button (click)="global.setSelectedLang(item.id)">
        {{ item.id }}
      </button>
    </div>
  </div> -->
        <!--
  <div class="lang-selector">
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <img class="flag" [src]="'assets/ui/flags/' + global.selectedLang + '.svg'" alt="">
    </button>
    <mat-menu #menu="matMenu">
      <button (click)="global.setSelectedLang(item.id)" *ngFor="let item of global.listLang" mat-menu-item>
        <img class="flag" [src]="'assets/ui/flags/' + item.id + '.svg'" alt="">
      </button>
    </mat-menu>
  </div> -->

        <div fxLayout="row">
          <p class="ok deviceName"
             [matMenuTriggerFor]="groups"
             *ngIf="sharedService.selectedDevice">
            {{ sharedService.selectedDevice.data.group }} >
            {{ sharedService.selectedDevice.data.name }}
          </p>
          <p class="warn deviceName"
             [matMenuTriggerFor]="groups"
             *ngIf="!sharedService.selectedDevice">
            {{ "noDeviceSelected" | translation }}
          </p>
          <button id="btn-group" mat-button [matMenuTriggerFor]="groups">
            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>
        </div>

        <mat-menu #groups="matMenu">
          <div *ngIf="sharedService.groupsArray.length > 1">
            <ng-container *ngFor="let group of sharedService.groupsArray">
              <button mat-menu-item [matMenuTriggerFor]="device">
                {{ group.name }}
              </button>

              <mat-menu #device="matMenu">
                <ng-container *ngFor="let device of sharedService.devicesArray">
                  <button *ngIf="device.data.group == group.name"
                          (click)="sharedService.setActiveBorne(device)"
                          mat-menu-item>
                    {{ device.data.name }}
                  </button>
                </ng-container>
              </mat-menu>
            </ng-container>
          </div>
          <div *ngIf="sharedService.groupsArray.length == 1">
            <ng-container *ngFor="let device of sharedService.devicesArray">
              <button mat-menu-item
                      (click)="sharedService.setActiveBorne(device)">
                {{ device.data.name }}
              </button>
            </ng-container>
          </div>
        </mat-menu>
      </section>

      <section>
        <!-- <span class="fill-space"></span> -->
        <ng-container> </ng-container>
        <div>

          <ng-container *ngIf="
              !(isHandset$ | async) && sharedService.selectedDevice != undefined
            ">
            <a mat-button
               routerLink="/global"
               routerLinkActive="page-is-active">{{ "global" | translation }}</a>
            <a mat-button
               [routerLink]="modules.path"
               routerLinkActive="page-is-active"
               *ngFor="let modules of arrayModulesToReturn">{{ modules.name | translation }}</a>
          </ng-container>
          <a *ngIf="firebaseService.user.role == 'mainuser'"
             mat-button
             routerLink="/usermanagement"
             routerLinkActive="page-is-active">{{ "usermanagement" | translation }}</a>
          <a *ngIf="firebaseService.user.role == 'mainuser'"
             mat-button
             routerLink="/register"
             routerLinkActive="page-is-active">{{ "register" | translation }}</a>
          <a *ngIf="firebaseService.user.email != null  && (activesModules.media || (activesModules.kiosk && checkAvailalbleKiosk()))"
             mat-button
             routerLink="/statistics"
             routerLinkActive="page-is-active">{{ "statistics" | translation }}</a>
        </div>

        <!-- **** Sélection de la langue **** -->
        <div class="lang-selector">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <img
              class="flag"
              [src]="'assets/ui/flags/' + global.selectedLang + '.svg'"
              alt=""
            />
          </button>

          <mat-menu #menu="matMenu">
            <button
              class="lang-selector-button"
              (click)="global.setSelectedLang(item.id)"
              *ngFor="let item of global.listLang"
              mat-menu-item
            >
              <img
                class="flag"
                [src]="'assets/ui/flags/' + item.id + '.svg'"
                alt=""
              />
              <span>{{ item.displayName }}</span>
            </button>
          </mat-menu>
        </div>

        <!-- **** USER INFOS / LOGOUT **** -->
        <div fxLayout="row" fxLayoutAlign="center center"  [matMenuTriggerFor]="accountMenu">
          <!-- <button (click)="openDialog()" mat-icon-button>
    
   </button>-->

          <button mat-icon-button aria-label="Example icon-button with a menu">
            <mat-icon>account_circle</mat-icon>
          </button>
          <mat-menu #accountMenu="matMenu">
            <button routerLink="/accountmanagement" mat-menu-item>
              <mat-icon>settings</mat-icon>
              <span>{{'accountManagement' | translation}}</span>
            </button>
            <button (click)="openDialog()" mat-menu-item>
              <mat-icon>logout</mat-icon>
              <span>{{'deco' | translation}}</span>
            </button>

          </mat-menu>

          <p 
             class="buttonUser"
             *ngIf="!(isHandset$ | async)">
            {{ firebaseService.user.displayName }}
          </p>
        </div>
      </section>
    </mat-toolbar>

    <!-- TRANSCLUSION -->

    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
